import React from 'react';
export function Footer() {
  return <footer className="bg-[#080a0f] border-t border-white/5 pt-[60px] pb-[30px] px-[5%]" data-id="element-53">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-[2fr_1fr_1fr] gap-[40px] lg:gap-[60px] mb-[50px]" data-id="element-54">
        <div data-id="element-55">
          <div className="h-[45px] w-[160px] bg-gradient-primary rounded-lg flex items-center justify-center font-rajdhani font-bold text-base tracking-[1px] border border-azul-neon/50 mb-[16px]" data-id="element-56">
            RANDAZZO
          </div>
          <p className="text-texto-gris text-[14px] leading-[1.7] mb-[24px] max-w-[300px]" data-id="element-57">
            Taller mecánico especializado en diagnóstico, reparación y
            potenciación de vehículos. San Luis, Argentina.
          </p>
          <div className="flex gap-[12px]" data-id="element-58">
            <a href="https://instagram.com/randazzoautomotor" target="_blank" rel="noreferrer" className="w-[40px] h-[40px] bg-white/5 border border-white/10 rounded-[10px] flex items-center justify-center text-texto-gris no-underline text-[16px] transition-all duration-300 hover:bg-azul-neon/20 hover:border-azul-neon/40 hover:text-acento" data-id="element-59">
              <i className="fab fa-instagram" data-id="element-60"></i>
            </a>
            <a href="https://wa.me/5492664XXXXXX" target="_blank" rel="noreferrer" className="w-[40px] h-[40px] bg-white/5 border border-white/10 rounded-[10px] flex items-center justify-center text-texto-gris no-underline text-[16px] transition-all duration-300 hover:bg-azul-neon/20 hover:border-azul-neon/40 hover:text-acento" data-id="element-61">
              <i className="fab fa-whatsapp" data-id="element-62"></i>
            </a>
          </div>
        </div>

        <div data-id="element-63">
          <h4 className="font-rajdhani text-[16px] font-bold uppercase tracking-[1px] mb-[20px] text-blanco" data-id="element-64">
            Servicios
          </h4>
          <ul className="list-none flex flex-col gap-[10px]" data-id="element-65">
            <li data-id="element-66">
              <a href="#servicios" className="text-texto-gris no-underline text-[14px] transition-colors duration-300 hover:text-blanco" data-id="element-67">
                Diagnóstico & Motor
              </a>
            </li>
            <li data-id="element-68">
              <a href="#servicios" className="text-texto-gris no-underline text-[14px] transition-colors duration-300 hover:text-blanco" data-id="element-69">
                ECU Stage / Tuning
              </a>
            </li>
            <li data-id="element-70">
              <a href="#servicios" className="text-texto-gris no-underline text-[14px] transition-colors duration-300 hover:text-blanco" data-id="element-71">
                Cajas Automáticas
              </a>
            </li>
            <li data-id="element-72">
              <a href="#servicios" className="text-texto-gris no-underline text-[14px] transition-colors duration-300 hover:text-blanco" data-id="element-73">
                Frenos & Suspensión
              </a>
            </li>
            <li data-id="element-74">
              <a href="#servicios" className="text-texto-gris no-underline text-[14px] transition-colors duration-300 hover:text-blanco" data-id="element-75">
                Electrónica Avanzada
              </a>
            </li>
          </ul>
        </div>

        <div data-id="element-76">
          <h4 className="font-rajdhani text-[16px] font-bold uppercase tracking-[1px] mb-[20px] text-blanco" data-id="element-77">
            Contacto
          </h4>
          <ul className="list-none flex flex-col gap-[10px]" data-id="element-78">
            <li data-id="element-79">
              <a href="#" className="text-texto-gris no-underline text-[14px] transition-colors duration-300 hover:text-blanco" data-id="element-80">
                Maipú 766, San Luis
              </a>
            </li>
            <li data-id="element-81">
              <a href="https://wa.me/5492664XXXXXX" target="_blank" rel="noreferrer" className="text-texto-gris no-underline text-[14px] transition-colors duration-300 hover:text-blanco" data-id="element-82">
                WhatsApp
              </a>
            </li>
            <li data-id="element-83">
              <a href="https://instagram.com/randazzoautomotor" target="_blank" rel="noreferrer" className="text-texto-gris no-underline text-[14px] transition-colors duration-300 hover:text-blanco" data-id="element-84">
                Instagram
              </a>
            </li>
            <li data-id="element-85">
              <a href="#ubicacion" className="text-texto-gris no-underline text-[14px] transition-colors duration-300 hover:text-blanco" data-id="element-86">
                Cómo llegar
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/5 pt-[28px] flex justify-between items-center flex-wrap gap-[12px] flex-col md:flex-row text-center md:text-left" data-id="element-87">
        <p className="text-texto-gris text-[13px]" data-id="element-88">
          © 2025 Randazzo Automotor — San Luis, Argentina
        </p>
        <p className="text-texto-gris text-[13px]" data-id="element-89">Guillermo Randazzo</p>
      </div>
    </footer>;
}